import React from 'react';
import { COLORS } from '../../theme';

const VARIANTES = {
  ghost: { bg: '#fff', border: COLORS.border, color: COLORS.textMid },
  secondary: { bg: COLORS.primaryBg, border: COLORS.primary, color: COLORS.primary },
  danger: { bg: COLORS.dangerBg, border: COLORS.danger, color: COLORS.danger },
  primary: { bg: COLORS.primary, border: COLORS.primary, color: '#fff' }
};

export default function IconBtn({ titulo, variante = 'ghost', onClick, disabled, children }) {
  const v = VARIANTES[variante] || VARIANTES.ghost;
  return (
    <button
      type="button"
      title={titulo}
      aria-label={titulo}
      onClick={onClick}
      disabled={disabled}
      style={{
        width: 34, height: 34, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
        borderRadius: 8, border: `1.5px solid ${v.border}`, background: v.bg, color: v.color,
        cursor: disabled ? 'default' : 'pointer', opacity: disabled ? 0.5 : 1, transition: 'opacity .15s'
      }}
      onMouseEnter={e => { if (!disabled) e.currentTarget.style.opacity = '0.8'; }}
      onMouseLeave={e => { e.currentTarget.style.opacity = disabled ? 0.5 : 1; }}
    >
      {children}
    </button>
  );
}
